export default "__VITE_ASSET__Da2_UINr__"